// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "body {\n    background-color: #19181D;\n    font-family: \"Quicksand,sans-serif\";\n}", "",{"version":3,"sources":["webpack://./src/frontend/css/global.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,mCAAmC;AACvC","sourcesContent":["body {\n    background-color: #19181D;\n    font-family: \"Quicksand,sans-serif\";\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
